import { articles } from "../content";
import { ArticleCard } from "../components/ArticleCard";
import { Callout } from "../components/Callout";
import { formatDate } from "../lib/article";
import { latestArticleDate } from "../lib/routes";

export function ArticlesPage() {
  const [lead, ...rest] = articles;

  return (
    <>
      <header className="page-head">
        <div className="wrap page-head__grid">
          <div>
            <p className="index-label">
              <span className="index-label__number">{articles.length} guides</span>
              <span>Updated {formatDate(latestArticleDate())}</span>
            </p>
            <h1 className="display">Understand what the water is telling you.</h1>
          </div>
          <p className="page-head__lede">Practical explanations for common aquarium problems, ecosystem fundamentals, aquatic pets, and the craft of building living underwater worlds.</p>
        </div>
      </header>
      <section className="article-index wrap" aria-label="Aquarium care guides">
        <ArticleCard article={lead} featured headingLevel="h2" />
        <div className="article-index__list">
          {rest.map((article) => <ArticleCard article={article} headingLevel="h2" key={article.id} />)}
        </div>
      </section>
      <div className="wrap callout-wrap"><Callout compact /></div>
    </>
  );
}
